import { render } from "./pswp.vue?vue&type=template&id=553e80d8"
import script from "./pswp.vue?vue&type=script&lang=js"
export * from "./pswp.vue?vue&type=script&lang=js"

import "./pswp.vue?vue&type=style&index=0&id=553e80d8&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__